import { Calendar, TimeOutline } from "@raresail/react-ionicons";
import {
  IconBox,
  ListItemWrapper,
  StatusTag,
} from "../../components/elements/Elements";
import { API_LOANS } from "../../constants/apis";
import { INSTALLMENTS } from "../../constants/constants";
import { searchFilterField } from "../../constants/options";
import { currencyFormat, formatDate, unsetKeys } from "../../utils/helpers";
import { openBottomSheet } from "../../utils/modalUtils";

export const useInstallmentsList = ({ state }: any) => {
  const { id: loanId } = state || {};

  const filters = [searchFilterField];

  const viewData = (data: any) => {
    const { due_date, status, amount_due, created_at, paid_amount } =
      data || {};

    return {
      ...unsetKeys(data, ["id"]),
      due_date: formatDate(due_date),
      created_at: formatDate(created_at),
      status: <StatusTag status={status} />,
      amount_due: currencyFormat(amount_due),
      paid_amount: currencyFormat(paid_amount),
    };
  };

  return {
    ListItem: InstallmentItem,
    api: `${API_LOANS}${loanId}/${INSTALLMENTS}/`,
    filters,
    getList: (data: any) => data?.installments, // return data from custom list
    viewData,
  };
};

const InstallmentItem = ({ data }: { data: any }) => {
  const { installment_number, due_date, amount_due, status } = data || {};
  return (
    <ListItemWrapper
      className="flexNullCenter gap15"
      onClick={() =>
        // open details view
        openBottomSheet({
          component: "details",
          title: "Installment Details",
          source: INSTALLMENTS,
          data,
        })
      }
    >
      <IconBox icon={Calendar} size={20} />
      <div className="flexGrow">
        <div className="font13 semiBold textDark capitalize mb5">
          Installment {installment_number}
        </div>

        {/* MID */}
        <div className="font12 main capitalize flexNullCenter gap5 ">
          <TimeOutline />
          Due {formatDate(due_date)}
        </div>
      </div>
      {/* END */}
      <div className="textEnd">
        <div className="font13 semiBold textDark mb5">
          {currencyFormat(amount_due)}
        </div>
        <StatusTag status={status} />
      </div>
    </ListItemWrapper>
  );
};
